import { store } from '@betacrew/jars-flux'
import { ADD_PAYER_SLICE_INITIAL_STATE } from './constant';
import { RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } from '../../constants/constants';

export const componentKey = "NEW_PAYER/ADD";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setMethodType: (state, action) => {
            state.methodType = action.payload;
        },
        setPayerType: (state, action) => {
            state.PayerType = action.payload;
        },
        setBasicInformation: (state, action) => {
            let basicInfo = { ...state.basicInfo };

            Object.entries(action.payload).map(([key, value]) => {
                basicInfo = {
                    ...state.basicInfo,
                    [key]: (typeof state.basicInfo[key] === 'object' && typeof value === 'object')
                    ? { ...state.basicInfo[key], ...value }
                    : value,
                };

                state.basicInfo = basicInfo;
            })
        },
        setAddressInformation: (state, action) => {

            let addressInformation = { ...state.addressInformation };

            Object.entries(action.payload).map(([key, value]) => {
                addressInformation = {
                    ...state.addressInformation,
                    [key]: {
                        ...state.addressInformation[key],
                        ...value
                    },
                };

                state.addressInformation = addressInformation;
            })

            // if country is updated then set the PayerState to the initial value
            if ('PayerCountry' in action.payload) {
                state.addressInformation.PayerState = { ...state.addressInformation.PayerState, label: "", value: "" };
                state.addressInformation.PayerZIP.value = "";

                if (action.payload.PayerCountry?.value !== "US") {
                    state.zipCodeValidationSuccess = true;
                } else {
                    state.zipCodeValidationSuccess = false;
                }
            }
            if ('PayerState' in action.payload && state.addressInformation.PayerZIP.value && state.addressInformation.PayerCountry.value == "US") {
                state.zipCodeValidationSuccess = false;
            }

        },
        setOptionalInformation: (state, action) => {
            let optionalInformation = { ...state.optionalInformation };

            Object.entries(action.payload).map(([key, value]) => {
                optionalInformation = {
                    ...state.optionalInformation,
                    [key]: {
                        ...state.optionalInformation[key],
                        ...value
                    },
                };

                state.optionalInformation = optionalInformation;
            })
        },
        setPayerCreationSuccessful: (state, action) => {
            state.payerCreationSuccessful = action.payload
        },
        setZipCodeValidationSuccess: (state, action) => {
            state.zipCodeValidationSuccess = action.payload
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setBasicInformationFieldsTouched: (state, action) => {
            state.basicInfo.allRequiredFieldsTouched = action.payload
        },
        setAddressInformationFieldsTouched: (state, action) => {
            state.addressInformation.allRequiredFieldsTouched = action.payload
        },
        setOptionalInformationFieldsTouched: (state, action) => {
            state.optionalInformation.allRequiredFieldsTouched = action.payload
        },
        setPayerUpdationSuccessful: (state, action) => {
            state.payerUpdationSuccessful = action.payload
        },
        setPayerDetailId: (state, action) => {
            state.PayerDetailId = action.payload;
        },
        setUserId: (state, action) => {
            state.UserId = action.payload;
        },
        resetAddPayerSlice: (state, action) => {
            Object.assign(state, ADD_PAYER_SLICE_INITIAL_STATE);

            let optionalInformation = { ...state.optionalInformation };

            optionalInformation.ClientID = {
                value: "",
                errors: {},
                rules: { required: action?.payload?.IsPayerClient ? true : false, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } }
            }

            optionalInformation.DisregardedEntity = {
                value: "",
                errors: {},
                rules: { required: action?.payload?.MultiplePayerLocation ? true : false }
            }

            state.optionalInformation = optionalInformation;
        },
        setNewlyAddedPayerData: (state, action) => {
            state.newlyAddedPayer = action.payload
        },
        setShowAssignToUserTable: (state, action) => {
            state.showAssignToUserTable = action.payload;
        }
    },
    initialReducerState: ADD_PAYER_SLICE_INITIAL_STATE
});

export const { setMethodType, setPayerType, setBasicInformation, setAddressInformation, setOptionalInformation, setPayerCreationSuccessful, setZipCodeValidationSuccess, setLoadingState, setBasicInformationFieldsTouched, setAddressInformationFieldsTouched, setOptionalInformationFieldsTouched, setPayerUpdationSuccessful, setSelectedPayer, setPayerDetailId, setUserId, resetAddPayerSlice, setNewlyAddedPayerData, setShowAssignToUserTable } = actions;